import { IFormContractResponse } from '../interfaces/formContractResponse';
import { IShadowUser } from '../interfaces/shadowUser';
import { ShadowUser } from './shadowUser';
import { IShadowGenericAnagraphic } from '../interfaces/shadowGenericAnagraphic';
import { IShadowGenericContract } from '../interfaces/shadowGenericContract';
import { IShadowStorageFileAttach } from '../interfaces/shadowStorageFileAttach';
import { IShadowSitePdrCatalogs } from '../interfaces/shadowSitePdrCatalogs';
import { IShadowSitePodCatalogs } from '../interfaces/shadowSitePodCatalogs';
import { PhaseContract } from '../enums/phaseContract.enum';
import { fillArray } from './_models.helper';
import { BrandType } from '../enums/brandType';
import { ShadowStorageFileAttach } from './shadowStorageFileAttach';
import { ShadowGenericContract } from './shadowGenericContract';
import { ShadowGenericAnagraphic } from './shadowGenericAnagraphic';
import { ShadowSitePdrCatalogs } from './shadowSitePdrCatalogs';
import { ShadowSitePodCatalogs } from './shadowSitePodCatalogs';

export class FormContractResponse implements IFormContractResponse {
    agent: IShadowUser = new ShadowUser();
    group: IShadowUser = new ShadowUser();
    client: IShadowGenericAnagraphic = new ShadowGenericAnagraphic();
    contract: IShadowGenericContract = new ShadowGenericContract();
    files: IShadowStorageFileAttach[] = new Array<IShadowStorageFileAttach>();
    owner: IShadowUser = new ShadowUser();
    pdrs: IShadowSitePdrCatalogs[] = new Array<IShadowSitePdrCatalogs>();
    pods: IShadowSitePodCatalogs[] = new Array<IShadowSitePodCatalogs>();
    representative: IShadowGenericAnagraphic = new ShadowGenericAnagraphic();
    isEditable: boolean;
    isDeletable: boolean;
    availablePhases: PhaseContract[] = new Array<PhaseContract>();
    isSignatureEditable: boolean;
    tableBrands: BrandType[];

    constructor(cr?: FormContractResponse) {
        if (cr) {
            this.agent = new ShadowUser(cr.agent);
            this.client = new ShadowGenericAnagraphic(cr.client);
            this.contract = new ShadowGenericContract(cr.contract);
            this.files = fillArray(cr.files, ShadowStorageFileAttach);
            this.owner = new ShadowUser(cr.owner);
            this.pdrs = fillArray(cr.pdrs, ShadowSitePdrCatalogs);
            this.pods = fillArray(cr.pods, ShadowSitePodCatalogs);
            this.representative = new ShadowGenericAnagraphic(cr.representative);
            this.isEditable = cr.isEditable;
            this.isDeletable = cr.isDeletable;
            this.isSignatureEditable = cr.isSignatureEditable;
            this.availablePhases = cr.availablePhases;
            this.group = cr.group;
            this.tableBrands = cr.tableBrands;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/formContractResponse.ts